// extracted by mini-css-extract-plugin
export default {"modelTabs":"lD7DJ_GW1JMKKVStot6G","tabButtonActive":"y62VGHVDyyOvhVEdsAMS","tabButton":"lRThxQZp2k08uCc3i1sK","searchIcon":"eqs9U4erAh5jbJhJhv4E"};